import styles from './Tour.module.css'
import type { TourChapter } from './chapters'

interface CompletionBeatProps {
  chapter: TourChapter
  nextChapter: TourChapter | null
  isFoundationDone: boolean
  onContinue: () => void   // start the next chapter
  onPause: () => void      // close, return to idle state
}

/**
 * The "stage done" moment between foundation chapters. The user must
 * explicitly choose to continue — no auto-chaining. This is what makes
 * pacing structural instead of implicit.
 */
export function CompletionBeat({
  chapter,
  nextChapter,
  isFoundationDone,
  onContinue,
  onPause,
}: CompletionBeatProps) {
  const beat = chapter.completionBeat ?? {
    title: `${chapter.title} — done.`,
    body: 'Take a moment when you\'re ready, the next chapter is in the tour pill.',
  }

  return (
    <div className={styles.beatWrap}>
      <div className={styles.beatDim} onClick={onPause} />
      <div
        className={styles.beatCard}
        role="dialog"
        aria-modal="true"
        aria-label={beat.title}
      >
        <div className={styles.beatCheckRing}>
          <i className="bi bi-check2" />
        </div>
        <div className={styles.beatEyebrow}>
          {isFoundationDone ? 'Foundation complete' : `Chapter done · ${chapter.title}`}
        </div>
        <h3 className={styles.beatTitle}>{beat.title}</h3>
        <p className={styles.beatBody}>{beat.body}</p>
        <div className={styles.beatActions}>
          <button className={styles.secondaryBtn} onClick={onPause}>
            {isFoundationDone ? 'Explore on my own' : 'Take a break'}
          </button>
          {nextChapter && (
            <button className={styles.primaryBtn} onClick={onContinue}>
              <span className={styles.primaryBtnLabel}>
                {isFoundationDone ? 'Browse more chapters' : `Next: ${nextChapter.title}`}
                <i className="bi bi-arrow-right" />
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
